import React from "react";
import ClarityBeforeCodeLogo from "../../assets/images/high-throughput-logo.png";
import FeaturesSelectionLogo from "../../assets/images/reliability-logo.png";
import OptimizedDevelopmentLogo from "../../assets/images/horizontal-scaling.png";
import FeedbackLoopLogo from "../../assets/images/maintainable-architecture-logo.png";
import SubscribeNewsLetter from "../../assets/images/subscribe-newsletter.png";

const steps = [
  {
    title: "HIGH THROUGHPUT",
    text: "Efficient architecture, background jobs, caching, and asynchronous processing ensure the system performs well under heavy load.",
    logo: ClarityBeforeCodeLogo
  },
  {
    title: "RELIABILITY",
    text: "Automatic retries, fault tolerance, monitoring, and graceful error handling minimize downtime and improve stability.",
    logo: FeaturesSelectionLogo
  },
  {
    title: "HORIZONTAL SCALABILITY",
    text: "Stateless services, distributed workloads, and load balancing make it easy to support growing demand.",
    logo: OptimizedDevelopmentLogo
  },
  {
    title: "MAINTAINABLE ARCHITECTURE",
    text: "Clean code, modular components, clear boundaries, and automated testing allow new features to be shipped confidently.",
    logo: FeedbackLoopLogo
  },
];

const MvpSteps = () => {
  return (
    <section className="mvp-steps" id="mvp-steps">
      <div className="container">
        <div className="mvp-steps__inner">
          <div className="mvp-steps__left">
            <span className="mvp-steps__label">YOU KNOW WHAT WORKS ?</span>
            <h2 className="mvp-steps__heading">
              SCALABLE SYSTEM ESSENTIALS
            </h2>
            <p className="mvp-steps__description">
              I've noticed a consistent pattern across systems that scale well: they aren't just built to work today, they're designed to handle growth from the start. These are the engineering principles I keep coming back to.
            </p>
            <div className="mvp-steps__actions">
              <a
                href="https://www.linkedin.com/newsletters/from-mvp-to-scale-7480876122033836033/"
                className="btn btn--outline"
                target="_blank"
                rel="noreferrer"
              >
                <img src={SubscribeNewsLetter} alt="" className="btn__icon" />
                Subscribe To My NewsLetter
              </a>
              <a href="#products" className="btn btn--outline">
                Explore My Work
              </a>
            </div>
          </div>

          <div className="mvp-steps__right">
            <ul className="mvp-steps__list">
              {steps.map((step, index) => (
                <li className="mvp-steps__item" key={index}>
                  <h3 className="mvp-steps__item-title">
                    <img src={step.logo} alt="" className="mvp-steps__item-icon" />
                    {step.title}
                  </h3>
                  <p className="mvp-steps__item-text">{step.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MvpSteps;
